import { createSelector } from 'reselect';
import { getLatestActivitySet } from './getLatestActivitySet';
import { getCurrentWorkOrderOp } from './getCurrentWorkOrderOp';
import { getPostLaborUpdatesOnNats } from './getPostLaborUpdatesOnNats';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';

const getWorkOrderId = createSelector(
  [
    getLatestActivitySet,
    getCurrentWorkOrderOp,
    getPostLaborUpdatesOnNats,
    getIsApmERPJobFlow,
  ],
  (activitySet, currentWorkOrderOp, natsFlowEnabled, isApmERPJobFlow) => {
    // APM ERP or NATS flow: work order op is source of truth
    if ((isApmERPJobFlow || natsFlowEnabled) && currentWorkOrderOp) {
      return currentWorkOrderOp.workOrderId;
    }

    // Standard flow: get from activity set
    return activitySet.workOrderId;
  }
);

export { getWorkOrderId };
